// extracted by mini-css-extract-plugin
export var sectionHeading = "topics-module--sectionHeading--prvrQ";
export var list = "topics-module--list--3i5sx";
export var listItem = "topics-module--listItem--9ehWV";
export var hyperlink = "topics-module--hyperlink--KvGzs";
export var twoColumnFlexContainer = "topics-module--twoColumnFlexContainer--Qsumu";
export var twoColumnFlexItem = "topics-module--twoColumnFlexItem--11Q-N";